import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {CookieConsentService} from './shared/services/Auth/business/cookie-consent.service';
import { IdleTimeoutService } from './shared/services/Auth/business/idle-timeout.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  
  constructor(
    private cookieConsentService: CookieConsentService,
    private idleTimeoutService: IdleTimeoutService
) {}

ngOnInit(): void {
    this.cookieConsentService.init();
    // Start idle timeout tracking (1 hour inactivity -> logout)
    this.idleTimeoutService.startWatching();
}
}
